<template>
  <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <!-- Overlay -->
    <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"></div>

    <!-- Modal Container -->
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-center justify-center p-4">
        <div class="relative transform overflow-hidden rounded-lg bg-gray-800 text-white shadow-xl transition-all sm:max-w-3xl w-full">
          <div class="p-6">
            <!-- Header -->
            <div class="flex justify-between items-center mb-6">
              <h3 class="text-xl font-semibold text-indigo-300">สร้างซอมบี้ใหม่</h3>
              <button @click="cancelModal" class="text-gray-400 hover:text-white">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <!-- Form -->
            <form @submit.prevent="createZombie">
              <!-- Basic Info Section -->
              <div class="space-y-4 mb-6">
                <h4 class="text-lg font-medium text-gray-300">ข้อมูลพื้นฐาน</h4>
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ชื่อซอมบี้</label>
                    <input
                      v-model="zombieName"
                      type="text"
                      placeholder="เช่น ซอมบี้ธรรมดา"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      required
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ลิงก์รูปภาพ</label>
                    <input
                      v-model="imageUrl"
                      type="url"
                      placeholder="https://example.com/image.jpg"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      required
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">เลเวลของซอมบี้</label>
                    <input
                      v-model.number="level"
                      type="number"
                      min="1"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      required
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ประเภทซอมบี้</label>
                    <select
                      v-model="zombieType"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      required
                    >
                      <option value="normal">ทั่วไป</option>
                      <option value="boss">บอส</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1 text-gray-300">คำอธิบาย</label>
                  <textarea
                    v-model="description"
                    class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    rows="2"
                    placeholder="อธิบายลักษณะหรือพฤติกรรมของซอมบี้"
                  ></textarea>
                </div>
              </div>

              <!-- Stats Section -->
              <div class="space-y-4 mb-6">
                <h4 class="text-lg font-medium text-gray-300">ค่าสถานะ</h4>
                <div class="grid grid-cols-2 sm:grid-cols-6 gap-4">
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">Stamina</label>
                    <input
                      v-model.number="stats.stamina"
                      type="number"
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">Strength</label>
                    <input
                      v-model.number="stats.str"
                      type="number"
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">Agility</label>
                    <input
                      v-model.number="stats.agi"
                      type="number"
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">Intelligence</label>
                    <input
                      v-model.number="stats.int"
                      type="number"
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">Defense</label>
                    <input
                      v-model.number="stats.defense"
                      type="number"
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">Luck</label>
                    <input
                      v-model.number="stats.luck"
                      type="number"
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>
                </div>
                <p v-if="statDifference < 0" class="text-sm text-yellow-500 mt-2">คำแนะนำ: ขาด {{ Math.abs(statDifference) }} หน่วย (ค่าสถานะรวมควรเป็น {{ expectedStatTotal }})</p>
                <p v-else-if="statDifference > 0" class="text-sm text-red-500 mt-2">คำแนะนำ: เกิน {{ statDifference }} หน่วย (ค่าสถานะรวมควรเป็น {{ expectedStatTotal }})</p>
                <p v-else class="text-sm text-green-500 mt-2">คำแนะนำ: ค่าสถานะครบถ้วน (ค่าสถานะรวม {{ expectedStatTotal }})</p>
                <div class="flex flex-wrap gap-2 mt-3">
                  <button type="button" @click="calculateStats('highHP')" class="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200">
                    ซอมบี้เลือดเยอะ
                  </button>
                  <button type="button" @click="calculateStats('highAttack')" class="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200">
                    ซอมบี้โจมตีแรง
                  </button>
                  <button type="button" @click="calculateStats('fast')" class="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200">
                    ซอมบี้วิ่งไว
                  </button>
                  <button type="button" @click="calculateStats('smart')" class="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200">
                    ซอมบี้ฉลาดมาก
                  </button>
                  <button type="button" @click="calculateStats('highDefense')" class="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200">
                    ซอมบี้พลังป้องกันสูง
                  </button>
                  <button type="button" @click="calculateStats('lucky')" class="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200">
                    ซอมบี้โชคดี
                  </button>
                </div>
              </div>

              <!-- Special Properties and Rewards Section -->
              <div class="space-y-4 mb-6">
                <h4 class="text-lg font-medium text-gray-300">คุณสมบัติพิเศษและรางวัล</h4>
                <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">โอกาสการติดเชื้อ (%)</label>
                    <input
                      v-model.number="infectionChance"
                      type="number"
                      min="0"
                      max="100"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">EXP ที่ได้รับ</label>
                    <input
                      v-model.number="expReward"
                      type="number"
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">Silver ที่ได้รับ</label>
                    <input
                      v-model.number="silverReward"
                      type="number"
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="flex justify-end gap-3">
                <button
                  type="submit"
                  class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                >
                  สร้างซอมบี้
                </button>
                <button
                  @click="cancelModal"
                  type="button"
                  class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition duration-200"
                >
                  ยกเลิก
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { projectFirestore } from '@/firebase/config';
import { ref, computed, watch, onMounted } from 'vue';

export default {
  setup(props, context) {
    const zombieName = ref('');
    const imageUrl = ref('');
    const level = ref(1);
    const zombieType = ref('normal'); // Default to normal
    const description = ref('');
    const stats = ref({
      stamina: 0,
      str: 0,
      agi: 0,
      int: 0,
      defense: 0,
      luck: 0,
    });
    const infectionChance = ref(10);
    const expReward = ref(10);
    const silverReward = ref(0);
    const now = new Date();

    // Function to update expReward and infectionChance based on level and type
    const updateRewards = () => {
      if (zombieType.value === 'boss') {
        expReward.value = 100; // Boss: 100 EXP for all levels
        infectionChance.value = 50; // Boss: 50% infection chance
      } else {
        // Normal zombie: EXP = 5 + 5 * level
        expReward.value = 5 + level.value * 5;
        infectionChance.value = 10; // Normal: 10% infection chance
      }
    };

    // Watch for changes in level and type
    watch([level, zombieType], () => {
      updateRewards();
    });

    // Calculate expected stat total based on level and type
    const expectedStatTotal = computed(() => {
      return zombieType.value === 'boss' ? level.value * 4 : level.value * 3;
    });

    // Calculate actual stat total
    const actualStatTotal = computed(() => {
      const s = stats.value;
      return (s.stamina || 0) + (s.str || 0) + (s.agi || 0) + (s.int || 0) + (s.defense || 0) + (s.luck || 0);
    });

    // Calculate difference between actual and expected stat totals
    const statDifference = computed(() => actualStatTotal.value - expectedStatTotal.value);

    const calculateStats = (type) => {
      const totalPoints = zombieType.value === 'boss' ? level.value * 5 : level.value * 3; // Total stat points based on type
      const staminaPoints = Math.round(totalPoints * 0.4); // 40% for stamina
      const primaryPoints = Math.round(totalPoints * 0.3); // 30% for primary stat
      const secondaryPoints = Math.round(totalPoints * 0.15); // 15% for each secondary stat

      // Calculate used points and remainder to ensure exact total
      const usedPoints = staminaPoints + primaryPoints + secondaryPoints * 2;
      const remainder = totalPoints - usedPoints; // Positive or negative remainder

      let newStats = { stamina: staminaPoints, str: 0, agi: 0, int: 0, defense: 0, luck: 0 };

      switch (type) {
        case 'highHP':
          newStats.str = secondaryPoints; // 15%
          newStats.agi = secondaryPoints + remainder; // 15% + remainder
          newStats.int = 0;
          newStats.defense = 0;
          newStats.luck = 0;
          break;
        case 'highAttack':
          newStats.str = primaryPoints; // 30%
          newStats.agi = secondaryPoints; // 15%
          newStats.int = secondaryPoints + remainder; // 15% + remainder
          newStats.defense = 0;
          newStats.luck = 0;
          break;
        case 'fast':
          newStats.agi = primaryPoints; // 30%
          newStats.str = secondaryPoints; // 15%
          newStats.int = secondaryPoints + remainder; // 15% + remainder
          newStats.defense = 0;
          newStats.luck = 0;
          break;
        case 'smart':
          newStats.int = primaryPoints; // 30%
          newStats.str = secondaryPoints; // 15%
          newStats.agi = secondaryPoints + remainder; // 15% + remainder
          newStats.defense = 0;
          newStats.luck = 0;
          break;
        case 'highDefense':
          newStats.defense = primaryPoints; // 30%
          newStats.str = secondaryPoints; // 15%
          newStats.agi = secondaryPoints + remainder; // 15% + remainder
          newStats.int = 0;
          newStats.luck = 0;
          break;
        case 'lucky':
          newStats.luck = primaryPoints; // 30%
          newStats.str = secondaryPoints; // 15%
          newStats.agi = secondaryPoints + remainder; // 15% + remainder
          newStats.int = 0;
          newStats.defense = 0;
          break;
      }

      // Ensure no negative stats
      Object.keys(newStats).forEach((key) => {
        if (newStats[key] < 0) newStats[key] = 0;
      });

      stats.value = newStats;
    };

    const cancelModal = () => {
      context.emit('cancelModal');
    };

    const createZombie = async () => {
      try {
        const zombieData = {
          name: zombieName.value,
          imageUrl: imageUrl.value,
          level: level.value,
          type: zombieType.value, // Add zombie type to data
          description: description.value,
          stats: {
            stamina: stats.value.stamina,
            str: stats.value.str,
            agi: stats.value.agi,
            int: stats.value.int,
            defense: stats.value.defense,
            luck: stats.value.luck,
          },
          infectionChance: infectionChance.value,
          expReward: expReward.value,
          silverReward: silverReward.value,
          createdAt: now,
          damageTaken: 0,
        };

        await projectFirestore.collection('gameZombies').doc(zombieName.value).set(zombieData);
        context.emit('zombieAdded');
        
        // Reset form
        zombieName.value = '';
        imageUrl.value = '';
        level.value = 1;
        zombieType.value = 'normal';
        description.value = '';
        stats.value = { stamina: 0, str: 0, agi: 0, int: 0, defense: 0, luck: 0 };
        infectionChance.value = 10;
        expReward.value = 10;
        silverReward.value = 0;
      } catch (error) {
        console.error('Error adding zombie:', error);
      }
    };

    onMounted(() => {
      updateRewards(); // Initialize rewards on mount
    });

    return { 
      zombieName,
      imageUrl,
      level,
      zombieType,
      description,
      stats,
      infectionChance,
      expReward,
      silverReward,
      expectedStatTotal,
      statDifference,
      calculateStats,
      createZombie,
      cancelModal,
    };
  },
};
</script>